import { FC, useContext } from 'react';
import { Menu, Spinner } from '@chakra-ui/react';

import { useRunOlasioRequest } from '~/core/shared/api/plugin';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import {
  ApplicationContext,
  DocumentDetailsViewActionContext,
} from '../Layout.component';

export const OlasioMenuItem: FC = () => {
  const { runOlasioRequest, isPending } = useRunOlasioRequest();
  const { applicationUuid } = useContext(ApplicationContext);

  const {
    action: { text },
  } = useContext(DocumentDetailsViewActionContext);

  const handleRunOlasioRequest = useEventHandler(async (): Promise<void> => {
    try {
      await runOlasioRequest({ params: { id: applicationUuid, assetId: '' } }); // we should use the new olasio asset select modal instead of this
    } catch (error) {
      console.error(error);
      // Error is handled in useRunOlasioRequest
    }
  });

  return (
    <Menu.Item onClick={handleRunOlasioRequest} value="olasio">
      {isPending && <Spinner size="xs" />}
      {text}
    </Menu.Item>
  );
};
